export const isNull = {
  methods: {
    isNull(data) {
      if (data == null || data == undefined || data == "") {
        return {
          id: "",
        };
      } else {
        return data;
      }
    },
  },
};
